const FetchStateEnum = {
  EMPTY: 'EMPTY',
  FAILED: 'FAILED',
  LOADING: 'LOADING',
  LOADED: 'LOADED'
}

const NextPageStateEnum = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  LOADING: 'LOADING',

  fromBoolean(bool) {
    return bool ? this.AVAILABLE : this.UNAVAILABLE
  }
}

module.exports = {
  FetchStateEnum,
  NextPageStateEnum
}
